var _defs, _rect, _ellipse, _ellipse2, _circle, _circle2, _g, _g2, _g3, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _text, _circle11, _circle12, _circle13, _text2, _circle14, _circle15, _circle16, _text3, _circle17, _circle18, _circle19, _text4, _circle20, _circle21, _circle22, _text5, _circle23, _circle24, _circle25, _text6, _circle26, _line, _circle27, _circle28, _line2, _circle29, _circle30, _line3, _circle31, _circle32, _line4, _circle33, _circle34, _line5, _circle35, _circle36, _line6, _circle37, _circle38, _circle39, _circle40, _circle41, _g4, _text7, _text8, _rect2, _circle42, _text9, _rect3, _text10, _text11, _text12, _text13, _text14, _text15, _rect4, _text16, _rect5, _text17, _text18, _text19, _text20, _text21, _text22;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlockchainIllustrationAura(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 680 440",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "hub-g",
    cx: "50%",
    cy: "50%",
    r: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#9333EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#4C1D95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "node-g",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C3AED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A855F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "card-g",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D1A5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1040"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hub-glow",
    x: "-80%",
    y: "-80%",
    width: "260%",
    height: "260%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 0,
    stdDeviation: 18,
    floodColor: "#8B5CF6",
    floodOpacity: 0.7
  })), /*#__PURE__*/React.createElement("filter", {
    id: "node-glow",
    x: "-60%",
    y: "-60%",
    width: "220%",
    height: "220%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 0,
    stdDeviation: 8,
    floodColor: "#7C3AED",
    floodOpacity: 0.45
  })), /*#__PURE__*/React.createElement("filter", {
    id: "sm-sf",
    x: "-25%",
    y: "-25%",
    width: "150%",
    height: "150%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 4,
    stdDeviation: 7,
    floodColor: "#1C1566",
    floodOpacity: 0.2
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 680,
    height: 500,
    rx: 24,
    fill: "url(#bg)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 340,
    cy: 225,
    rx: 280,
    ry: 250,
    fill: "#8B5CF6",
    fillOpacity: 0.07
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 420,
    cy: 180,
    rx: 200,
    ry: 180,
    fill: "#93C5FD",
    fillOpacity: 0.08
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 340,
    cy: 225,
    r: 215,
    stroke: "#A78BFA",
    strokeOpacity: 0.1,
    strokeWidth: 1,
    strokeDasharray: "8,8"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 340,
    cy: 225,
    r: 170,
    stroke: "#A78BFA",
    strokeOpacity: 0.08,
    strokeWidth: 1,
    strokeDasharray: "6,10"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#A78BFA",
    strokeOpacity: 0.3,
    strokeWidth: 1.3,
    strokeDasharray: "5,5"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 418,
    y1: 91,
    x2: 495,
    y2: 225
  }), /*#__PURE__*/React.createElement("line", {
    x1: 418,
    y1: 91,
    x2: 263,
    y2: 91
  }), /*#__PURE__*/React.createElement("line", {
    x1: 263,
    y1: 91,
    x2: 185,
    y2: 225
  }), /*#__PURE__*/React.createElement("line", {
    x1: 185,
    y1: 225,
    x2: 263,
    y2: 359
  }), /*#__PURE__*/React.createElement("line", {
    x1: 263,
    y1: 359,
    x2: 418,
    y2: 359
  }), /*#__PURE__*/React.createElement("line", {
    x1: 418,
    y1: 359,
    x2: 495,
    y2: 225
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    stroke: "#A78BFA",
    strokeOpacity: 0.12,
    strokeWidth: 1,
    strokeDasharray: "4,7"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 418,
    y1: 91,
    x2: 263,
    y2: 359
  }), /*#__PURE__*/React.createElement("line", {
    x1: 263,
    y1: 91,
    x2: 418,
    y2: 359
  }), /*#__PURE__*/React.createElement("line", {
    x1: 185,
    y1: 225,
    x2: 495,
    y2: 225
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    stroke: "#8B5CF6",
    strokeOpacity: 0.55,
    strokeWidth: 1.8,
    strokeDasharray: "7,5"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 340,
    y1: 225,
    x2: 418,
    y2: 91
  }), /*#__PURE__*/React.createElement("line", {
    x1: 340,
    y1: 225,
    x2: 263,
    y2: 91
  }), /*#__PURE__*/React.createElement("line", {
    x1: 340,
    y1: 225,
    x2: 185,
    y2: 225
  }), /*#__PURE__*/React.createElement("line", {
    x1: 340,
    y1: 225,
    x2: 263,
    y2: 359
  }), /*#__PURE__*/React.createElement("line", {
    x1: 340,
    y1: 225,
    x2: 418,
    y2: 359
  }), /*#__PURE__*/React.createElement("line", {
    x1: 340,
    y1: 225,
    x2: 495,
    y2: 225
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 379,
    cy: 158,
    r: 5.5,
    fill: "#34D399",
    stroke: "white",
    strokeWidth: 1.8
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 301,
    cy: 158,
    r: 5.5,
    fill: "#FBBF24",
    stroke: "white",
    strokeWidth: 1.8
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 262,
    cy: 225,
    r: 5.5,
    fill: "#34D399",
    stroke: "white",
    strokeWidth: 1.8
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 301,
    cy: 292,
    r: 5.5,
    fill: "#34D399",
    stroke: "white",
    strokeWidth: 1.8
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 379,
    cy: 292,
    r: 5.5,
    fill: "#A78BFA",
    stroke: "white",
    strokeWidth: 1.8
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 418,
    cy: 225,
    r: 5.5,
    fill: "#34D399",
    stroke: "white",
    strokeWidth: 1.8
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 418,
    cy: 91,
    r: 24,
    fill: "#C4B5FD",
    fillOpacity: 0.2
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 418,
    cy: 91,
    r: 17,
    fill: "url(#node-g)",
    filter: "url(#node-glow)"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 418,
    y: 95,
    textAnchor: "middle",
    fill: "#F5F3FF",
    fontSize: 8,
    fontWeight: 700,
    fontFamily: "Arial, sans-serif"
  }, "N2")), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 429,
    cy: 80,
    r: 5.5,
    fill: "#34D399",
    stroke: "white",
    strokeWidth: 1.5
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 263,
    cy: 91,
    r: 24,
    fill: "#C4B5FD",
    fillOpacity: 0.2
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 263,
    cy: 91,
    r: 17,
    fill: "url(#node-g)",
    filter: "url(#node-glow)"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 263,
    y: 95,
    textAnchor: "middle",
    fill: "#F5F3FF",
    fontSize: 8,
    fontWeight: 700,
    fontFamily: "Arial, sans-serif"
  }, "N3")), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 274,
    cy: 80,
    r: 5.5,
    fill: "#FBBF24",
    stroke: "white",
    strokeWidth: 1.5
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 185,
    cy: 225,
    r: 24,
    fill: "#C4B5FD",
    fillOpacity: 0.2
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 185,
    cy: 225,
    r: 17,
    fill: "url(#node-g)",
    filter: "url(#node-glow)"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 185,
    y: 229,
    textAnchor: "middle",
    fill: "#F5F3FF",
    fontSize: 8,
    fontWeight: 700,
    fontFamily: "Arial, sans-serif"
  }, "N4")), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 196,
    cy: 214,
    r: 5.5,
    fill: "#34D399",
    stroke: "white",
    strokeWidth: 1.5
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 263,
    cy: 359,
    r: 24,
    fill: "#C4B5FD",
    fillOpacity: 0.2
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 263,
    cy: 359,
    r: 17,
    fill: "url(#node-g)",
    filter: "url(#node-glow)"
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 263,
    y: 363,
    textAnchor: "middle",
    fill: "#F5F3FF",
    fontSize: 8,
    fontWeight: 700,
    fontFamily: "Arial, sans-serif"
  }, "N5")), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 274,
    cy: 348,
    r: 5.5,
    fill: "#F87171",
    stroke: "white",
    strokeWidth: 1.5
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 418,
    cy: 359,
    r: 24,
    fill: "#C4B5FD",
    fillOpacity: 0.2
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 418,
    cy: 359,
    r: 17,
    fill: "url(#node-g)",
    filter: "url(#node-glow)"
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 418,
    y: 363,
    textAnchor: "middle",
    fill: "#F5F3FF",
    fontSize: 8,
    fontWeight: 700,
    fontFamily: "Arial, sans-serif"
  }, "N6")), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 429,
    cy: 348,
    r: 5.5,
    fill: "#34D399",
    stroke: "white",
    strokeWidth: 1.5
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 495,
    cy: 225,
    r: 24,
    fill: "#C4B5FD",
    fillOpacity: 0.2
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 495,
    cy: 225,
    r: 17,
    fill: "url(#node-g)",
    filter: "url(#node-glow)"
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 495,
    y: 229,
    textAnchor: "middle",
    fill: "#F5F3FF",
    fontSize: 8,
    fontWeight: 700,
    fontFamily: "Arial, sans-serif"
  }, "N1")), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 506,
    cy: 214,
    r: 5.5,
    fill: "#34D399",
    stroke: "white",
    strokeWidth: 1.5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 429,
    y1: 78,
    x2: 458,
    y2: 38,
    stroke: "#A78BFA",
    strokeDasharray: "3,5",
    strokeOpacity: 0.6,
    strokeWidth: 1.2
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 465,
    cy: 30,
    r: 9,
    fill: "#7C3AED",
    fillOpacity: 0.22
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 465,
    cy: 30,
    r: 5.5,
    fill: "#7C3AED"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 252,
    y1: 78,
    x2: 222,
    y2: 38,
    stroke: "#A78BFA",
    strokeDasharray: "3,5",
    strokeOpacity: 0.6,
    strokeWidth: 1.2
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 215,
    cy: 30,
    r: 9,
    fill: "#7C3AED",
    fillOpacity: 0.22
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 215,
    cy: 30,
    r: 5.5,
    fill: "#7C3AED"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 512,
    y1: 225,
    x2: 582,
    y2: 225,
    stroke: "#A78BFA",
    strokeDasharray: "3,5",
    strokeOpacity: 0.6,
    strokeWidth: 1.2
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 592,
    cy: 225,
    r: 9,
    fill: "#7C3AED",
    fillOpacity: 0.22
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 592,
    cy: 225,
    r: 5.5,
    fill: "#7C3AED"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 168,
    y1: 225,
    x2: 98,
    y2: 225,
    stroke: "#A78BFA",
    strokeDasharray: "3,5",
    strokeOpacity: 0.6,
    strokeWidth: 1.2
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 88,
    cy: 225,
    r: 9,
    fill: "#7C3AED",
    fillOpacity: 0.22
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: 88,
    cy: 225,
    r: 5.5,
    fill: "#7C3AED"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 252,
    y1: 372,
    x2: 222,
    y2: 412,
    stroke: "#A78BFA",
    strokeDasharray: "3,5",
    strokeOpacity: 0.6,
    strokeWidth: 1.2
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: 215,
    cy: 420,
    r: 9,
    fill: "#7C3AED",
    fillOpacity: 0.22
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: 215,
    cy: 420,
    r: 5.5,
    fill: "#7C3AED"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 429,
    y1: 372,
    x2: 458,
    y2: 412,
    stroke: "#A78BFA",
    strokeDasharray: "3,5",
    strokeOpacity: 0.6,
    strokeWidth: 1.2
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: 465,
    cy: 420,
    r: 9,
    fill: "#7C3AED",
    fillOpacity: 0.22
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: 465,
    cy: 420,
    r: 5.5,
    fill: "#7C3AED"
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    cx: 340,
    cy: 225,
    r: 72,
    fill: "#7C3AED",
    fillOpacity: 0.14
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    cx: 340,
    cy: 225,
    r: 54,
    fill: "#6D28D9",
    fillOpacity: 0.18
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    cx: 340,
    cy: 225,
    r: 46,
    fill: "url(#hub-g)",
    filter: "url(#hub-glow)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(340,219)",
    stroke: "white",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -20,
    y: -7,
    width: 12,
    height: 10,
    rx: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: -4,
    y: -7,
    width: 8,
    height: 10,
    rx: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: -7,
    width: 12,
    height: 10,
    rx: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: -8,
    y1: -2,
    x2: -4,
    y2: -2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: -2,
    x2: 8,
    y2: -2
  }))), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 340,
    y: 236,
    textAnchor: "middle",
    fill: "white",
    fontSize: 10.5,
    fontWeight: 700,
    fontFamily: "Arial, sans-serif"
  }, "META")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 340,
    y: 249,
    textAnchor: "middle",
    fill: "#EDE9FE",
    fontSize: 8.5,
    fontWeight: 700,
    fontFamily: "Arial, sans-serif"
  }, "QUALT")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 14,
    width: 164,
    height: 30,
    rx: 15,
    fill: "#10B981",
    fillOpacity: 0.15,
    stroke: "#10B981",
    strokeWidth: 1.4
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    cx: 277,
    cy: 29,
    r: 5.5,
    fill: "#10B981"
  })), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 349,
    y: 34,
    textAnchor: "middle",
    fill: "#10B981",
    fontSize: 10.5,
    fontWeight: 700,
    fontFamily: "Arial, sans-serif"
  }, "LIVE NETWORK")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 518,
    y: 130,
    width: 138,
    height: 54,
    rx: 12,
    fill: "url(#card-g)",
    filter: "url(#sm-sf)"
  })), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 532,
    y: 150,
    fill: "#A78BFA",
    fontSize: 8,
    fontWeight: 600,
    fontFamily: "Arial, sans-serif"
  }, "Hash")), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 556,
    y: 150,
    fill: "#C4B5FD",
    fontSize: 8,
    fontFamily: "monospace"
  }, "#A39C 5D12 ...")), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 532,
    y: 166,
    fill: "#A78BFA",
    fontSize: 8,
    fontWeight: 600,
    fontFamily: "Arial, sans-serif"
  }, "Status")), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 560,
    y: 166,
    fill: "#34D399",
    fontSize: 8,
    fontWeight: 700,
    fontFamily: "Arial, sans-serif"
  }, "&#10003; Confirmed")), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 532,
    y: 177,
    fill: "#A78BFA",
    fontSize: 8,
    fontWeight: 600,
    fontFamily: "Arial, sans-serif"
  }, "Block")), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 555,
    y: 177,
    fill: "#DDD6FE",
    fontSize: 8,
    fontFamily: "monospace"
  }, "#1024")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 540,
    y: 76,
    width: 120,
    height: 30,
    rx: 15,
    fill: "#FBBF24"
  })), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 600,
    y: 96,
    textAnchor: "middle",
    fill: "#1E1B4B",
    fontSize: 10.5,
    fontWeight: 800,
    fontFamily: "Arial, sans-serif"
  }, "NEW BLOCK")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 295,
    width: 140,
    height: 54,
    rx: 12,
    fill: "url(#card-g)",
    filter: "url(#sm-sf)"
  })), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    x: 38,
    y: 315,
    fill: "#FBBF24",
    fontSize: 8,
    fontWeight: 600,
    fontFamily: "Arial, sans-serif"
  }, "Nonce")), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 315,
    fill: "#FDE68A",
    fontSize: 8,
    fontFamily: "monospace"
  }, "Solving...")), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    x: 38,
    y: 331,
    fill: "#FBBF24",
    fontSize: 8,
    fontWeight: 600,
    fontFamily: "Arial, sans-serif"
  }, "Txns")), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    x: 62,
    y: 331,
    fill: "#FCD34D",
    fontSize: 8,
    fontWeight: 700,
    fontFamily: "Arial, sans-serif"
  }, "198 pending")), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    x: 38,
    y: 341,
    fill: "#FBBF24",
    fontSize: 8,
    fontWeight: 600,
    fontFamily: "Arial, sans-serif"
  }, "Block")), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    x: 62,
    y: 341,
    fill: "#FDE68A",
    fontSize: 8,
    fontFamily: "monospace"
  }, "#1025")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockchainIllustrationAura);
export default __webpack_public_path__ + "static/media/BlockchainIllustrationAura.04ee462eace1590c7deb17159e94ca3d.svg";
export { ForwardRef as ReactComponent };